import React from 'react';
import { connect } from 'react-redux';
import { setFiltroSeller } from '../../actions/sellersActions';
import PropTypes from 'prop-types';

class FiltroSellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            razonSocial: this.props.filtro?.razonSocial ?? ""
        }
    };

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.props.setFiltroSeller({ ...this.props.filtro, [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        this.props.getSellers();
        this.props.setFiltroSeller({ ...this.props.filtro, numeroPagina: 1 });
    }

    onClear = () => {
        this.setState({ razonSocial: "" });
        this.props.clearFilter();
    }

    render() {
        const { inline } = this.props;
        return (
            <div className={inline ? "" : "card card-body filter-card"}>
                <form
                    className={`row align-items-end form-material ${inline ? "g-2 justify-content-end" : "justify-content-evenly"}`}
                    onSubmit={this.onSubmit}
                    onReset={this.onClear}
                >
                    <div className={inline ? "col-auto" : "col-12 col-sm-3 pb-2"}>
                        <label htmlFor="razonSocialSeller" className="label-oscura">Razon Social</label>
                        <input
                            type="text"
                            id="razonSocialSeller"
                            name="razonSocial"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.razonSocial}
                            style={inline ? { minWidth: "220px" } : undefined}
                        />
                    </div>

                    <div className={inline ? "col-auto d-flex align-items-end gap-2" : "col-12 col-sm-6 text-center text-sm-end mt-sm-3"}>
                        <button
                            type="submit"
                            className={`btn btn-sm btn-grey ${inline ? "" : "mt-2 mt-sm-0"}`}
                        >
                            Buscar
                        </button>

                        <button
                            type="reset"
                            className={`btn btn-sm btn-grey ${inline ? "" : "ms-2 ms-sm-2 mt-2 mt-sm-0"}`}
                        >
                            Limpiar
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}
FiltroSellers.propTypes = {
    // PROPS DE REDUX
    filtro: PropTypes.oneOfType([PropTypes.shape({
        razonSocial: PropTypes.string
    }), PropTypes.array]),

    // PROPS DE ACTIONS
    setFiltroSeller: PropTypes.func,
    getSellers: PropTypes.func,
    clearFilter: PropTypes.func,
    inline: PropTypes.bool,
}


const mapStateToProps = state => ({
    sellers: state.sellers.sellers,
    filtro: state.sellers.filtro
});

export default connect(mapStateToProps, { setFiltroSeller })(FiltroSellers);